import { passwordRules } from 'config/validators/passwordRules';

const validation_messages = {
  required: ['validation>>general>>required', 'Required field'],
  agreement_required: ['validation>>general>>agreement_required', 'Agreement is required'],
  agreements_required_general: ['validation>>general>>agreements_required_general', 'Check required agreements'],
  password_required: ['validation>>password>>required', 'Enter your password'],
  password_match: ['validation>>password>>match', "Passwords don't match"],
  email_required: ['validation>>email>>required', 'Enter your email'],
  email_valid: ['validation>>email>>valid', 'Enter a valid email'],
  missing_required_snackbar: ['validation>>missing_required_snackbar', 'Fill all required fields'],
  email_in_use: ['validation>>email>>email_in_use', 'Email is already registered'],
  guide_need_one_step: ['validation>>guide>>guide_need_one_step', 'Guide needs at least one step'],
  year_activity_needs_one_category: ['validation>>year_activity>>year_activity_needs_one_category', 'Activity needs at least one category'],
  date_from_cannot_be_after_date_to: ['validation>>date_from_cannot_be_after_date_to', 'Date from cannot be after date to'],
  date_to_cannot_be_before_date_from: ['validation>>date_to_cannot_be_before_date_from', 'Date to cannot be before date from'],
  date_cannot_be_in_future: ['validation>>date_cannot_be_in_future', 'Date cannot be in the future'],
  date_cannot_be_in_past: ['validation>>date_cannot_be_in_past', 'Date cannot be in the past'],
  errors: {
    credentials: ['validation>>errors>>credentials', 'Incorrect credentials'],
    too_many_attempts: ['validation>>errors>>to_many_attempts', 'To many attempts, account temporarily locked'],
    whitespaces: ['validation>>password>>whitespaces', 'whitespaces are not allowed'],
    lowercase_letter: ['validation>>password>>lowercase_letter', 'at least 1 lowercase letter'],
    uppercase_letter: ['validation>>password>>uppercase_letter', 'at least 1 uppercase letter'],
    special_character: ['validation>>password>>special_character', 'at least 1 special character, !@#$%&*()-+=^.'],
    digit: ['validation>>password>>digit', 'at least 1 digit'],
    match: ['validation>>password>>match', "Passwords don't match"],
    range: ['validation>>password>>range', 'from {{min}} to {{max}} characters long', passwordRules],
  },
  recaptcha_not_ready: ['validation>>recaptcha>>not_ready', 'Recaptcha is not ready yet'],
  recaptcha_invalid: ['validation>>recaptcha>>recaptcha_invalid', 'Invalid recaptcha'],
  file_type_not_allowed: ['validation>>file>>file_type_not_allowed', 'This file type is not allowed'],
  file_too_large: ['validation>>file>>file_too_large', 'File exceeds the maximum size of {{maxSizeMb}} MB'],
};

export default validation_messages;
